
// PasteReferenceModal.jsx
import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Spinner } from 'react-bootstrap';

const PasteReferenceModal = ({ show, onHide, onPaste, onRefresh }) => {
    const [reference, setReference] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Réinitialiser le formulaire à chaque ouverture
    useEffect(() => {
        if (show) {
            setReference('');
            setError('');
            setLoading(false);
        }
    }, [show]);

    const handlePaste = async () => {
        try {
            const text = await navigator.clipboard.readText();
            setReference(text);
            setError('');
        } catch (err) {
            console.error('Échec de lecture du presse-papiers :', err);
            setError('Impossible d\'accéder au presse-papiers');
        }
    };

    const handleSubmit = async () => {
        if (!reference?.trim()) {
            setError('Veuillez entrer une référence valide');
            return;
        }

        setLoading(true);
        setError('');

        try {
            await onPaste(reference);
            if (onRefresh) {
                await onRefresh();
            }
            setReference('');
        } catch (error) {
            setError(error.message || 'Erreur lors de la confirmation');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={!loading}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                backdropFilter: 'blur(5px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Modal.Header closeButton={!loading}>
                <Modal.Title>Coller la Référence</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}>
                    <Form.Group controlId="formReference">
                        <Form.Label>Numéro de Référence</Form.Label>
                        <Form.Control
                            type="text"
                            value={reference}
                            onChange={(e) => {
                                setReference(e.target.value);
                                setError('');
                            }}
                            disabled={loading}
                            isInvalid={!!error}
                            placeholder="Entrez ou collez la référence ici"
                        />
                        <Form.Control.Feedback type="invalid">
                            {error}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form>

                <Button
                    variant="secondary"
                    onClick={handlePaste}
                    className="mt-3"
                    disabled={loading}
                >
                    <i className="fas fa-paste me-2"></i>
                    Coller depuis le Presse-Papiers
                </Button>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={onHide}
                    disabled={loading}
                >
                    Annuler
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={loading || !reference.trim()}
                >
                    {loading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Confirmation en cours...
                        </>
                    ) : (
                        'Confirmer'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PasteReferenceModal;